export default "/images/dc591469216331fe6727619503b82265.avif";